import type { Card, Content, NavItem } from './content';

const pt: Content = {
  langLabel: 'Idioma',
  menuLabel: 'Abrir menu',
  nav: [
    { label: '//RESULTADOS', href: '/#proof' },
    { label: '//PROCESSO', href: '/#process' },
    { label: '//SERVIÇOS', href: '/#services' },
    { label: '//CASES', href: '/#work' },
    { label: '//MANAGEDOPS', href: '/#managedops' },
    { label: '//FAQ', href: '/#faq' },
  ] as NavItem[],
  navExtra: [
    { label: '//BLOG', href: '/blog' },
    { label: '//CARREIRAS', href: '/careers-opportunity' },
  ] as NavItem[],
  navStatus: 'ACEITANDO PROJETOS',
  navContact: 'CONTATO',

  hero: {
    eyebrow: '//ENGENHARIA DE IA FORWARD-DEPLOYED',
    titleA: 'IA QUE CHEGA DE VERDADE À',
    titleB: 'PRODUÇÃO',
    sub: 'A Alio integra engenheiros sênior ao seu time para colocar agentes de IA, RAG e automações em produção, e depois os mantém funcionando. Feito para organizações reguladas e operacionalmente complexas.',
    subStrong: 'Seguro. Governado. Do seu time.',
    rotorTag: '//O QUE O TIME ENTREGA',
    rotor: [
      ['AGENTES DE IA', 'EM PRODUÇÃO'],
      ['RAG', 'NO SEU STACK'],
      ['COMPLIANCE', 'NO PIPELINE'],
      ['QA', 'EM CADA RELEASE'],
      ['GASTO CLOUD', '30-40% MENOR'],
    ] as [string, string][],
    rotorMeta: 'PROJETO OU RETAINER MANAGEDOPS',
    ctaPrimary: 'AGENDE UMA CONSULTA',
    ctaGhost: 'VER CASES',
    meta: ['DESDE 2011', 'EUA · MÉXICO · ÍNDIA', 'HUMANOS NO CIRCUITO', 'PRODUÇÃO, NÃO DEMOS'],
  },

  terminal: {
    title: 'alio engagement.log',
    chip: 'SESSÃO DE EXEMPLO',
    aria: 'Sessão de exemplo de um projeto com a Alio',
  },

  proof: {
    title: 'RESULTADOS',
    chip: 'DE PROJETOS REAIS',
    sub: 'Números de projetos entregues e cases publicados. Sem pilotos, sem projeções.',
    mainLabel: 'ACAPS · PLATAFORMA DE IA HUMANITÁRIA',
    mainLabelDim: 'agentes + RAG com pgvector',
    big: [
      { to: 70, suffix: '%', cap: 'MENOS TEMPO DE ANALISTAS', tone: 'accent' },
      { to: 60, suffix: '%', cap: 'MENOR CUSTO DE BUSCA', tone: 'plain' },
    ],
    bars: [
      { name: 'Testes automatizados NinjaOne', value: 60, label: '~60%' },
      { name: 'Compliance mais rápido (Drata)', value: 60, label: '60%' },
      { name: 'Time to market mais rápido', value: 40, label: '40%' },
      { name: 'Economia cloud (FinOps)', value: 40, label: '30-40%' },
      { name: 'Economia em migração cloud', value: 35, label: '35%' },
    ],
    log: [
      { text: '· acaps: OpenSearch substituído por pgvector, RAG multilíngue', stat: '-60%', href: '/white-papers' },
      { text: '· ninjaone: automação de ~1.000 testes de regressão, TDD', stat: '~60%', href: '/case-studies/ninjaone' },
      { text: '· usahs: sincronização clínica Salesforce + Jenzabar + Core', stat: 'NO AR', href: '/case-studies/usahs' },
    ],
    sideA: {
      chip: '⌘ PRESENÇA',
      label: 'desde 2011',
      to: 3,
      suffix: '',
      cap: 'PAÍSES · UM TIME',
      rows: ['ARIZONA, EUA', 'HERMOSILLO, MX', 'NOIDA, IN'],
    },
    sideB: {
      chip: '⌘ ALCANCE',
      label: 'setores atendidos',
      to: 14,
      suffix: '+',
      cap: 'REGULADOS + OPERACIONAIS',
      rows: ['SAÚDE · FINTECH · SEGUROS', 'EDTECH · UTILITIES · MANUFATURA'],
    },
  },

  clients: {
    title: 'QUEM CONFIA',
    chip: '14 TIMES',
    partnersLabel: 'parceiros',
    partners: 'AWS · MICROSOFT · SALESFORCE · OPENAI · DRATA · GITLAB · MONGODB COE · GOOGLE CLOUD · BRAINCODERS.IO · ARIZONA TECHNOLOGY COUNCIL',
  },

  process: {
    title: 'PROCESSO',
    chip: '5 ETAPAS · 1 TIME',
    sub: 'Entra um fluxo de trabalho quebrado. Sai um sistema em produção que o seu time controla. Cada etapa entrega evidências para a próxima.',
    steps: [
      { num: '01', tag: '//DESCOBRIR', title: 'INTENÇÃO → MAPA DE FLUXOS', body: 'Sentamos com seus operadores, analistas e lideranças para encontrar onde o trabalho realmente quebra. O mapa vem antes do modelo.' },
      { num: '02', tag: '//INTEGRAR', title: 'MAPA → TIME', body: 'Engenheiros sênior dos EUA, México e Índia entram nas suas dailies, nos seus repositórios e nos seus canais. Mesmo horário, mesmos objetivos.' },
      { num: '03', tag: '//CONSTRUIR', title: 'TIME → SISTEMAS', body: 'Agentes, pipelines de RAG, integrações e infraestrutura cloud, entregues em sprints contra critérios de aceite aprovados por você.' },
      { num: '04', tag: '//VERIFICAR', title: 'SISTEMAS → EVIDÊNCIAS', body: 'QA automatizado, avaliações, revisão de segurança e mapeamento de compliance. Revisão humana onde o risco é real.' },
      { num: '05', tag: '//OPERAR', title: 'EVIDÊNCIAS → AUTONOMIA', body: 'Runbooks e transferência de conhecimento para que o seu time seja dono do sistema. Ou mantenha a gente via ManagedOps e seguimos melhorando.' },
    ],
    flow: ['descobrir', 'integrar', 'construir', 'verificar', 'operar'],
    flowEnd: 'repetir até funcionar no seu ambiente',
  },

  services: {
    title: 'SERVIÇOS',
    chip: 'IA PRIMEIRO · FULL STACK',
    sub: 'Não um fornecedor generalista. Times especializados em IA, cloud, segurança e entrega, em um único contrato.',
    cards: [
      { tag: '//PRINCIPAL', title: 'Engenharia de IA forward-deployed', body: 'Engenheiros sênior se integram aos seus operadores, mapeiam os fluxos quebrados e colocam agentes, RAG e automações em produção. Não demos que ficam na gaveta.', href: '/solutions/ai-engineering', variant: 'primary' },
      { tag: '//OPERAÇÕES', title: 'Alio ManagedOps', body: 'Operações de engenharia gerenciadas, não um help desk. Cloud, DevOps, QA, segurança e IA, em melhoria contínua com um retainer mensal.', href: '/managedops' },
      { tag: '//CLOUD', title: 'Cloud e DevOps', body: 'AWS, Azure e GCP. CI/CD, infraestrutura como código, observabilidade e FinOps que corta 30-40% do gasto cloud.', href: '/services' },
      { tag: '//SEGURANÇA', title: 'Cibersegurança e vCISO', body: 'Liderança em segurança sem contratar em tempo integral. Programas de risco, preparação para auditorias, planos de incidentes e revisão de fornecedores.', href: 'https://vciso.alioit.com' },
      { tag: '//SAÚDE', title: 'HealthTech e interoperabilidade', body: 'Mapeamento HL7 FHIR, SMART on FHIR e USCDI, com prontidão para HIPAA, SOC 2 e HITRUST desde o início.', href: 'https://healthtech.alioit.com' },
      { tag: '//QA', title: 'Automação de QA', body: 'Selenium, Cypress, Playwright e Katalon. Geração de testes assistida por IA com revisão humana. Nada vai para produção no escuro.', href: '/case-studies/ai-qa-automation' },
      { tag: '//CRM', title: 'Salesforce', body: 'Sales, Service e Marketing Cloud. Administradores e desenvolvedores certificados para implantações, integrações e migração de dados.', href: '/case-studies/salesforce' },
      { tag: '//DESENVOLVIMENTO', title: 'Desenvolvimento de software', body: 'Apps web, mobile e cloud com React, Node.js, Java, Python, Go e .NET. Mentalidade de produto, prontos para lançar.', href: '/services' },
      { tag: '//MAIS', title: '+5 outros', body: 'UX/UI · engenharia de dados · Web3 · PLM para manufatura · recrutamento →', href: '/services', variant: 'more' },
    ] as Card[],
  },

  stack: {
    title: 'STACK',
    chip: 'SEU AMBIENTE, NÃO O NOSSO',
    sub: 'Aprendemos a sua plataforma em vez de vender uma nova. Se ela move o seu negócio, conseguimos entregar sobre ela.',
    last: '+ SEU STACK',
    note: '// integrar com os sistemas de registro, não contorná-los',
  },

  work: {
    title: 'CASES',
    chip: 'ESTUDOS DE CASO',
    sub: 'Entregues e funcionando. Clique para ver a arquitetura, o stack e o resultado.',
    cards: [
      { tag: '//IA HUMANITÁRIA', title: 'ACAPS', body: 'Plataforma de conhecimento com IA para inteligência humanitária. Agentes, RAG com pgvector e processamento LLM multilíngue.', stat: '-70% TEMPO DE ANALISTAS', href: '/white-papers' },
      { tag: '//MSP · SAAS B2B', title: 'NinjaOne', body: 'Parceria de QA remoto que automatiza um programa de ~1.000 testes e impulsiona o desenvolvimento orientado a testes.', stat: '~60% AUTOMATIZADO', href: '/case-studies/ninjaone' },
      { tag: '//ENSINO SUPERIOR', title: 'USAHS', body: 'Integração de estágios clínicos e dados de alunos entre Salesforce, Jenzabar e Core. Menos conciliação manual.', stat: '3 SISTEMAS EM SINCRONIA', href: '/case-studies/usahs' },
      { tag: '//EDTECH', title: 'Time4Learning', body: 'Plataforma de ensino PreK-12. Suporte a aplicações, desenvolvimento web e mobile, UX/UI. Desde 2022.', stat: 'DESDE 2022', href: '/case-studies/time4learning' },
      { tag: '//FINTECH', title: 'Nerito', body: 'Plataforma de pagamentos para a população desbancarizada do México. Pagamentos móveis, depósitos e saques em AWS serverless.', stat: 'SERVERLESS', href: '/case-studies/nerito' },
      { tag: '//QA COM IA', title: 'QA aumentado por IA', body: 'Modelo de QA com IA usando Katalon, Jira, QMetry e Copilot CLI. Scripts mais rápidos, triagem de falhas mais rápida.', stat: 'IA + REVISÃO HUMANA', href: '/case-studies/ai-qa-automation' },
    ] as Card[],
  },

  managedops: {
    title: 'MANAGEDOPS',
    chip: 'SEGURO · ESTÁVEL · OTIMIZADO',
    sub: 'O lançamento é o começo, não o fim. O ManagedOps melhora a sua cloud, segurança, QA e IA todo mês com um retainer baseado em resultados.',
    plansLabel: '//PLANOS MENSAIS',
    plansDim: 'definidos após a avaliação',
    colPlan: 'PLANO',
    colScope: 'ESCOPO',
    colPrice: 'RETAINER',
    plans: [
      { name: 'ESSENTIALS', desc: 'Revisão mensal de operações, suporte a tickets, backlog de cloud, segurança e QA', price: '$3.5K-$7K/MÊS' },
      { name: 'GROWTH', desc: 'Suporte a CI/CD, FinOps, manutenção de QA, remediação de segurança, revisões executivas', price: '$7.5K-$14K/MÊS' },
      { name: 'ENTERPRISE', desc: 'Operação completa de cloud, IA, QA, segurança e compliance, com liderança dedicada', price: '$15K-$30K+/MÊS' },
    ],
    plansFoot: '// o preço final depende do escopo da plataforma, horas de suporte, requisitos de compliance e SLAs de resposta',
    vsLabel: '⌘ MSP TRADICIONAL → ALIO MANAGEDOPS',
    vs: [
      ['Help desk', 'Operações de engenharia'],
      ['Gestão de dispositivos', 'Cloud, DevOps, QA, IA, segurança'],
      ['Tickets reativos', 'Melhoria contínua'],
      ['Preço por usuário', 'Retainers baseados em resultados'],
    ] as [string, string][],
    vsFoot: '// detalhes completos em',
    areas: [
      { title: 'CLOUD E DEVOPS GERENCIADOS', body: 'AWS, Azure, GCP. Monitoramento de CI/CD, manutenção de IaC, FinOps, observabilidade e suporte em produção.' },
      { title: 'CIBERSEGURANÇA E vCISO', body: 'Consultoria, preparação para auditorias, planos de resposta a incidentes, remediação de riscos e revisão de fornecedores.' },
      { title: 'SEGURANÇA HEALTHTECH', body: 'Avaliações de risco HIPAA, prontidão para SOC 2 e HITRUST, proteção de PHI e treinamento em segurança.' },
      { title: 'AUTOMAÇÃO DE QA', body: 'Manutenção de regressão, prontidão de releases e triagem de falhas. Testes gerados por IA, revisados por humanos.' },
      { title: 'DESENVOLVIMENTO DE AGENTES DE IA', body: 'Agentes de domínio, ferramentas e pipelines de RAG com avaliações, verificações de segurança e fluxos com humanos no circuito.' },
      { title: 'OPERAÇÕES DE IA', body: 'Manutenção de modelos, prompts e RAG, governança de IA, e monitoramento de custo e desempenho entre fornecedores.' },
    ],
    cta: 'AGENDE UMA AVALIAÇÃO MANAGEDOPS',
  },

  principles: {
    title: 'PRINCÍPIOS',
    chip: 'COMO TRABALHAMOS',
    rows: [
      { num: '01', title: 'PRODUÇÃO, NÃO DEMOS', body: 'Se não está rodando no seu ambiente, não está pronto. Um piloto é um passo, nunca a entrega.' },
      { num: '02', title: 'HUMANOS NO CIRCUITO', body: 'A IA potencializa o seu time; nunca substitui o julgamento. Há revisão humana onde o risco é real.' },
      { num: '03', title: 'COMPLIANCE POR PADRÃO', body: 'Os controles HIPAA, SOC 2, ISO 27001 e GDPR são mapeados enquanto construímos... não adicionados na semana antes da auditoria.' },
      { num: '04', title: 'O SISTEMA É DO SEU TIME', body: 'Documentação, runbooks e mentoria em todo projeto. Planejamos a transição desde o primeiro dia.' },
    ],
  },

  faq: {
    title: 'FAQ',
    chip: '[ + ] EXPANDE',
    items: [
      { q: 'O que é engenharia de IA forward-deployed?', a: 'Engenheiros sênior da Alio se integram à sua organização para descobrir os fluxos de trabalho reais e, em seguida, constroem e colocam agentes de IA, sistemas RAG e automações no seu ambiente de produção, com governança humana no circuito e transferência de conhecimento para que o seu time mantenha o controle. Disponível como projeto ou como serviço contínuo de ManagedOps.' },
      { q: 'Qual a diferença para staff augmentation ou um MSP?', a: 'Staff augmentation entrega pessoas. Um MSP entrega um help desk. A Alio entrega resultados: engenheiros sênior responsáveis pela descoberta, entrega e operação, por projeto ou com um retainer ManagedOps baseado em resultados.' },
      { q: 'Com quais setores vocês trabalham?', a: 'Saúde, FinTech, seguros, EdTech e ensino superior, plataformas SaaS e MSP, manufatura, mineração, logística, utilities, cooperativas elétricas, streaming, cibersegurança e organizações humanitárias sem fins lucrativos.' },
      { q: 'Como vocês tratam segurança e compliance?', a: 'Consultoria vCISO, segurança HealthTech, integração de segurança com Microsoft Purview e AWS, e automação de compliance com Drata para SOC 2, ISO 27001, HIPAA e GDPR, cerca de 60% mais rápida que um programa manual.' },
      { q: 'Vocês trabalham junto com o nosso time interno?', a: 'Sim. Entramos nas suas cerimônias Scrum para engenharia de IA, DevOps, automação de QA, frontend, pipelines de dados e UX, ou operamos de forma contínua com um retainer ManagedOps.' },
      { q: 'Como começa um projeto?', a: 'Com uma conversa. Agende uma consulta geral ou uma avaliação ManagedOps de 30 minutos. Definimos o escopo, alocamos os engenheiros e começamos pela descoberta.' },
    ],
  },

  cta: {
    eyebrow: '//CONECTE',
    titleA: 'PARE DE PILOTAR',
    titleB: 'COMECE A ENTREGAR',
    sub: 'Traga o fluxo de trabalho que vive quebrando. Nós trazemos o time que entrega a solução.',
    primary: 'AGENDE UMA CONSULTA',
    ghost: 'AVALIAÇÃO MANAGEDOPS',
  },

  contact: {
    title: 'CONTATO',
    chip: 'EUA · MX · IN',
    sub: 'Conte o que continua quebrando e onde roda. Voltamos com um plano, não com um discurso de vendas.',
    officesLabel: '//ESCRITÓRIOS',
    regions: { usa: 'EUA', mexico: 'MÉXICO', india: 'ÍNDIA' },
    formLabel: '//BRIEFING DO PROJETO',
    formDim: 'new_engagement.form',
    required: '* obrigatório',
    sending: 'ENVIANDO...',
    orBook: '// prefere conversar agora?',
    orBookLink: 'agende uma consulta →',
  },

  footer: {
    tag: 'SEU TIME REMOTO, MAS MAIS PERTO.',
    status: 'EUA · MX · IN ONLINE',
    cols: [
      { head: '//SERVIÇOS', links: [
        { label: 'Engenharia de IA', href: '/solutions/ai-engineering' },
        { label: 'ManagedOps', href: '/managedops' },
        { label: 'Todos os serviços', href: '/services' },
        { label: 'vCISO →', href: 'https://vciso.alioit.com' },
      ] },
      { head: '//EMPRESA', links: [
        { label: 'Empresa', href: '/company' },
        { label: 'Estudos de caso', href: '/case-studies' },
        { label: 'Carreiras', href: '/careers-opportunity' },
        { label: 'Comunidade', href: '/community' },
      ] },
      { head: '//RECURSOS', links: [
        { label: 'Blog', href: '/blog' },
        { label: 'White papers', href: '/white-papers' },
        { label: 'Portfólio UI/UX', href: '/uiux-portfolio' },
        { label: 'Privacidade', href: '/privacy' },
      ] },
    ],
    legalA: '© 2026 ALIO IT SOLUTIONS LLC · ARIZONA · HERMOSILLO · NOIDA',
    legalB: '+1 (520) 261-1117',
  },
};

export default pt;
